import type { ChatModuleApi } from '@ekhodealer/ekho-common';
import type { ModuleDescriptor } from '../module-descriptor';

import { hasNativeChatSurface } from '../native-chat-surface';

function noop(): void {}

export const chatDescriptor: ModuleDescriptor<ChatModuleApi> = {
  name: 'chat',

  fallbackApi: { open: noop, destroy: noop },

  getBundleUrl(config) {
    if (config.disabled || !config.modules.chat?.enabled) return null;
    // The host page renders the widget itself, so mounting here would collide on
    // the shared `#ekho-shadow-host` and stack two launchers.
    if (hasNativeChatSurface()) return null;
    // Widget requires Shadow DOM to render.
    if (!('attachShadow' in Element.prototype)) return null;
    return config.moduleManifest.chat ?? null;
  },

  extractApi(loaded) {
    const api = loaded.api as Partial<ChatModuleApi> | undefined;
    return {
      open: typeof api?.open === 'function' ? api.open.bind(api) : noop,
      destroy: typeof api?.destroy === 'function' ? api.destroy.bind(api) : noop,
    };
  },
};
